import { createContext, useContext } from "react";

/**
 * A helper to create a Context and Provider with no upfront default value, and
 * without having to check for undefined all the time.
 */

export function createCtx<T extends {} | null>() {
  const ctx = createContext<T | undefined>(undefined);

  function useCtx<K>() {
    const c = useContext(ctx);

    if (c === undefined) {
      throw new Error("useCtx must be inside a Provider with a value");
    }

    return c as T & K;
  }

  return [useCtx, ctx.Provider, ctx] as const;
}
